import React, { useEffect, useRef } from 'react';
// Quill y su CSS se cargan dinámicamente para reducir el bundle inicial

export default function RichTextEditor({ id, label, initialContent, onChange }) {
  const editorRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    let quillInstance = null;

    const initQuill = async () => {
      const [{ default: Quill }] = await Promise.all([
        import('quill'),
        import('quill/dist/quill.snow.css'),
      ]);

      // Evitar doble instancia si el efecto se ejecuta dos veces en Strict Mode
      if (!containerRef.current || quillInstance) return;

      quillInstance = new Quill(containerRef.current, {
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'], // Opciones de formato
            [{ list: 'ordered' }, { list: 'bullet' }], // Listas ordenadas y sin orden
            ['image', 'link'], // Opciones de inserción
          ],
        },
      });

      // Establecer contenido inicial
      quillInstance.clipboard.dangerouslyPasteHTML(initialContent || '');

      // Sincronizar cambios con el input oculto
      quillInstance.on('text-change', () => {
        const html = containerRef.current.querySelector('.ql-editor').innerHTML;
        editorRef.current.value = html;
        if (onChange) onChange(html); // Disparar onChange externo si se proporcionó
      });
    };

    initQuill();

    return () => {
      quillInstance = null;
    };
  }, [initialContent, onChange]);

  return (
    <div className="sm:col-span-3 pb-10">
      <label htmlFor={id} className="block text-sm font-medium leading-6 text-gray-900">
        {label}
      </label>
      <div ref={containerRef} className="quill-container" />
      <input
        type="hidden"
        id={id}
        name={id}
        ref={editorRef}
        defaultValue={initialContent || ''}
      />
    </div>
  );
}
